/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const ViewIcon: React.SFC = () => {
    return (
        <svg width="32" height="17" viewBox="0 0 32 17">
          <g fill="#CFD8DD" fillRule="evenodd">
            <path d="M16.2279184 17c-5.4652374 0-10.4568998-2.3737408-14.974987-7.1212225-.734966-.772282-.7349655-1.985309.000001-2.7575902l.000017.000016C5.771032 2.3737346 10.7626884 0 16.2279185 0c5.4652374 0 10.4568998 2.3737408 14.974987 7.1212225.734966.772282.7349656 1.9853088-.000001 2.7575902l-.000017-.000016C26.684805 14.6262654 21.6931484 17 16.2279184 17zm0-2.5185185c3.2107775 0 5.813627-2.6780005 5.813627-5.9814815s-2.6028495-5.9814815-5.813627-5.9814815c-3.2107775 0-5.813627 2.6780005-5.813627 5.9814815s2.6028495 5.9814815 5.813627 5.9814815z"/>
            <circle cx="16.5712891" cy="8.5712891" r="2.5712891"/>
          </g>
        </svg>
    )
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/View/View.tsx